import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { authGoogleSession } from '../api';
import { useAuth, nextRoute } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { applyAuth, refresh } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    window.history.replaceState(null, '', location.pathname);
    if (!sessionId) { navigate('/login', { replace: true }); return; }
    authGoogleSession(sessionId)
      .then(async ({ token, user }) => {
        applyAuth(token, user);
        try { await refresh(); } catch (e) {}
        navigate(nextRoute(user), { replace: true });
      })
      .catch((err) => setError(err?.response?.data?.detail || 'Login Google gagal, coba lagi.'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-cream-100 flex flex-col items-center justify-center gap-4 px-5" data-testid="auth-callback">
      <div className="w-14 h-14 rounded-full bg-terracotta-500 flex items-center justify-center animate-pulse">
        <Heart className="w-7 h-7 text-white" fill="white" />
      </div>
      {error ? (
        <>
          <p className="text-red-500 text-sm" data-testid="auth-callback-error">{error}</p>
          <button onClick={() => navigate('/login', { replace: true })} className="text-terracotta-500 text-sm underline">Kembali ke halaman masuk</button>
        </>
      ) : <p className="text-sage-500 text-sm">Menyambungkan akun Google...</p>}
    </div>
  );
}
